import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import empty from "../../assets/images/empty-box.png";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faStar } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import moment from "moment";

export default function Reviews() {
  const [review, setReview] = useState([]);
  const [selectedReview, setSelectedReview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Form Modal (Add / Edit)
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [formMode, setFormMode] = useState("add"); // "add" | "edit"
  const [currentEditId, setCurrentEditId] = useState(null);
  const [formval, setFormval] = useState({
    name: "",
    rating: 5,
    student_desc: "",
    status: "active",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [existingImage, setExistingImage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${baseUrl}/student`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      setReview(response.data.data || []);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await axios.patch(
        `${baseUrl}/student/${id}`,
        { status: newStatus },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      setReview((prevReviews) =>
        prevReviews.map((rev) =>
          rev._id === id ? { ...rev, status: newStatus } : rev
        )
      );

      toast.success("Status updated successfully!");
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status. Please try again.");
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseUrl}/student/${id}`, {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          });

          setReview((prevReviews) => prevReviews.filter((rev) => rev._id !== id));
          toast.success("Deleted successfully!");
        } catch (error) {
          console.error("Error deleting:", error);
          toast.error("Failed to delete. Please try again.");
        }
      }
    });
  };

  const openAddModal = () => {
    setFormMode("add");
    setCurrentEditId(null);
    setFormval({
      name: "",
      rating: 5,
      student_desc: "",
      status: "active",
    });
    setSelectedFile(null);
    setPreviewUrl(null);
    setExistingImage("");
    setIsFormModalOpen(true);
  };

  const openEditModal = (item) => {
    setFormMode("edit");
    setCurrentEditId(item._id);
    setFormval({
      name: item.name || "",
      rating: Number(item.rating) || 5,
      student_desc: item.student_desc || "",
      status: item.status || "active",
    });
    setSelectedFile(null);
    setPreviewUrl(null);
    setExistingImage(item.student_photo ? `${baseUrl}/${item.student_photo}` : "");
    setIsFormModalOpen(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormval((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!formval.name.trim()) {
      return toast.error("Student name is required");
    }

    if (!formval.rating || formval.rating < 1 || formval.rating > 5) {
      return toast.error("Rating must be between 1 and 5");
    }

    const formData = new FormData();
    formData.append("name", formval.name.trim());
    formData.append("rating", formval.rating);
    formData.append("student_desc", formval.student_desc || "");
    formData.append("status", formval.status || "active");

    if (selectedFile) {
      formData.append("student_photo", selectedFile);
    }

    try {
      setSubmitting(true);
      const url =
        formMode === "edit"
          ? `${baseUrl}/student/${currentEditId}`
          : `${baseUrl}/student`;

      const method = formMode === "edit" ? "patch" : "post";

      const response = await axios({
        method,
        url,
        data: formData,
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.data?.status) {
        toast.success(
          formMode === "edit"
            ? "Review updated successfully!"
            : "Review added successfully!"
        );
        setIsFormModalOpen(false);
        fetchCategories();
      } else {
        toast.error(response?.data?.message || "Failed to save review");
      }
    } catch (error) {
      console.error("Error saving review:", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <section className="main-sec">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                Reviews
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Review List
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-6 d-flex justify-content-end align-items-center">
            <button
              onClick={openAddModal}
              className="btn btn-for-add text-white"
              style={{ minWidth: "150px" }}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              Add Review
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <h5 className="card-title">Review List</h5>
                  </div>
                  <div className="col-lg-6 text-end">
                    <button
                      onClick={openAddModal}
                      className="btn btn-for-add text-white btn-sm"
                    >
                      <FontAwesomeIcon icon={faPlus} className="me-1" />
                      Add Review
                    </button>
                  </div>
                </div>
              </div>
              <div className="table table-responsive custom-table">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>By</th>
                      <th>Review</th>
                      <th>Rating</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {review.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="py-5 text-center">
                          <img src={empty} alt="" width="200px" />
                          <h4 className="py-2">No Reviews found!</h4>
                        </td>
                      </tr>
                    ) : (
                      review?.map((rev, i) => {
                        return (
                          <tr key={rev?._id || i}>
                            <td>{i + 1}</td>
                            <td>
                              <div className="d-flex align-items-center">
                                {rev?.student_photo ? (
                                  <img
                                    src={`${baseUrl}/${rev?.student_photo}`}
                                    alt={rev?.name}
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                      marginRight: "10px",
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = "none";
                                    }}
                                  />
                                ) : null}
                                <span className="fw-semibold">{rev?.name}</span>
                              </div>
                            </td>
                            <td>{rev?.student_desc || "-"}</td>
                            <td className="text-warning">
                              {Array.from({ length: +rev?.rating || 0 }, (_, idx) => (
                                <i key={idx} className="fa fa-star ms-1" />
                              ))}
                            </td>
                            <td>
                              {moment(rev?.createdAt).format("lll")}
                            </td>
                            <td>
                              <select
                                value={rev?.status}
                                onChange={(e) =>
                                  handleStatusChange(rev?._id, e.target.value)
                                }
                                className={
                                  rev.status === "active"
                                    ? "form-select form-select-sm text-primary"
                                    : "form-select form-select-sm text-danger"
                                }
                              >
                                <option value="active">Showing</option>
                                <option value="inactive">Hidden</option>
                              </select>
                            </td>

                            <td>
                              <div className="action-buttons">
                                <button
                                  className="action-btn edit-btn"
                                  onClick={() => openEditModal(rev)}
                                >
                                  <i className="fa fa-edit"></i>
                                  <span className="tooltip-text">Edit</span>
                                </button>

                                <button
                                  className="action-btn view-btn"
                                  onClick={() => {
                                    setSelectedReview(rev);
                                    setIsModalOpen(true);
                                  }}
                                >
                                  <i className="fa fa-eye"></i>
                                  <span className="tooltip-text">View</span>
                                </button>

                                <button
                                  className="action-btn delete-btn"
                                  onClick={() => handleDelete(rev._id)}
                                >
                                  <i className="fa fa-trash"></i>
                                  <span className="tooltip-text">Delete</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* View Review Modal */}
      {isModalOpen && selectedReview && (
        <div className="custom-modal-wrapper">
          <div
            className="custom-modal-backdrop"
            onClick={() => setIsModalOpen(false)}
          ></div>
          <div className="custom-modal-box">
            <div className="custom-modal-header">
              <h4>Review Details</h4>
              <button className="close-btn" onClick={() => setIsModalOpen(false)}>
                &times;
              </button>
            </div>
            <div className="custom-modal-body">
              {selectedReview.student_photo && (
                <div className="review-image">
                  <img
                    src={`${baseUrl}/${selectedReview.student_photo}`}
                    alt={selectedReview.name}
                    onError={(e) => (e.target.src = "/placeholder.png")}
                  />
                </div>
              )}
              <div className="review-details">
                <p>
                  <strong>Name:</strong> {selectedReview.name}
                </p>
                <p>
                  <strong>Description:</strong> {selectedReview.student_desc || "-"}
                </p>
                <p>
                  <strong>Rating:</strong> {selectedReview.rating} ⭐
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span className={`status-tag ${selectedReview.status}`}>
                    {selectedReview.status === "active" ? "Showing" : "Hidden"}
                  </span>
                </p>
                <p>
                  <strong>Created At:</strong>{" "}
                  {new Date(selectedReview.createdAt).toLocaleString()}
                </p>
              </div>
            </div>
            <div className="custom-modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setIsModalOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add / Edit Review Modal */}
      {isFormModalOpen && (
        <div className="custom-modal-wrapper">
          <div
            className="custom-modal-backdrop"
            onClick={() => !submitting && setIsFormModalOpen(false)}
          ></div>
          <div className="custom-modal-box form-modal-box">
            <div className="custom-modal-header">
              <h4>{formMode === "edit" ? "Edit Review" : "Add Review"}</h4>
              <button
                className="close-btn"
                onClick={() => !submitting && setIsFormModalOpen(false)}
              >
                &times;
              </button>
            </div>
            <form onSubmit={handleFormSubmit}>
              <div className="custom-modal-body">
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Student Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formval.name}
                    onChange={handleInputChange}
                    placeholder="Enter student name"
                    required
                  />
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Rating (1 - 5) <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="rating"
                      value={formval.rating}
                      onChange={handleInputChange}
                      required
                    >
                      <option value={5}>5 Stars - Excellent ⭐⭐⭐⭐⭐</option>
                      <option value={4}>4 Stars - Very Good ⭐⭐⭐⭐</option>
                      <option value={3}>3 Stars - Good ⭐⭐⭐</option>
                      <option value={2}>2 Stars - Fair ⭐⭐</option>
                      <option value={1}>1 Star - Poor ⭐</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Status</label>
                    <select
                      className="form-control"
                      name="status"
                      value={formval.status}
                      onChange={handleInputChange}
                    >
                      <option value="active">Showing (Active)</option>
                      <option value="inactive">Hidden (Inactive)</option>
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Review / Description
                  </label>
                  <textarea
                    className="form-control"
                    name="student_desc"
                    rows="3"
                    value={formval.student_desc}
                    onChange={handleInputChange}
                    placeholder="Enter student review or feedback..."
                  ></textarea>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Student Photo</label>
                  {(previewUrl || existingImage) && (
                    <div className="mb-2 text-center">
                      <img
                        src={previewUrl || existingImage}
                        alt="Student Preview"
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid #ddd",
                        }}
                      />
                    </div>
                  )}
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                  <small className="text-muted">
                    Recommended: Square image (e.g. 200x200 px)
                  </small>
                </div>
              </div>

              <div className="custom-modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={() => setIsFormModalOpen(false)}
                  disabled={submitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-for-add text-white"
                  disabled={submitting}
                >
                  {submitting ? (
                    <>
                      <i className="fa fa-spinner fa-spin me-1"></i> Saving...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-save me-1"></i>{" "}
                      {formMode === "edit" ? "Update Review" : "Save Review"}
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style>{`
.custom-modal-wrapper {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-modal-box {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: fadeIn 0.3s ease;
  z-index: 1051;
}

.form-modal-box {
  max-width: 550px;
}

.custom-modal-header {
  padding: 16px 24px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-modal-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: #777;
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: #000;
}

.custom-modal-body {
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
}

.review-image img {
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
  max-height: 250px;
}

.review-details p {
  margin-bottom: 8px;
  font-size: 15px;
  color: #333;
}

.status-tag {
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  text-transform: capitalize;
}

.status-tag.active {
  background-color: #d1f7d1;
  color: #2e7d32;
}

.status-tag.inactive {
  background-color: #fddede;
  color: #c62828;
}

.custom-modal-footer {
  padding: 16px 24px;
  background-color: #fafafa;
  text-align: right;
  border-top: 1px solid #eee;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  transition: transform 0.2s ease;
  position: relative;
}

.action-btn:hover {
  transform: translateY(-2px);
}

.action-btn.edit-btn {
  background-color: #28a745;
}

.action-btn.view-btn {
  background-color: #17a2b8;
}

.action-btn.delete-btn {
  background-color: #dc3545;
}

.tooltip-text {
  visibility: hidden;
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}

.action-btn:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

@keyframes fadeIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
      `}</style>
    </>
  );
}
